export namespace UserSettingsModels {
  export enum DisplayMode {
    Auto = 'Auto',
    Mobile = 'Mobile',
    Desktop = 'Desktop',
  }

  export enum EmailFrequency {
    REAL_TIME = 'realTime',
    DAILY = 'daily',
    WEEKLY = 'weekly',
  }

  export enum DeviceChannel {
    CAMERA = 'camera',
    CORE = 'core',
  }

  export interface DeviceStabilityUserOverride {
    camera?: EmailFrequency[];
    core?: EmailFrequency[];
  }

  export interface DeviceEmailChannelOption {
    key: DeviceChannel;
    label: string;
  }

  export interface DeviceEmailFrequencyOption {
    value: EmailFrequency;
    label: string;
  }

  export interface UserSettingsBaseDocument {
    hoursFormat: HoursFormat;
    dateFormat: UiUserSettingsDateFormat;
    autoLogout: number;
    autoLogoutEnabled: boolean;
    theme: UserSettingsModels.Theme;
    alertMonitoringMuted: boolean;
    lang: UserSettingsModels.LANGUAGE;
    subForWeekly?: boolean;
    newDevicePageView?: boolean;
    globalSearchSettings?: GlobalSearchSettingsModel;
    viewMode?: DisplayMode;
    menuMode?: DisplayMode;
    deviceStability?: DeviceStabilityUserOverride;
  }

  export interface UserSettingsDocument extends UserSettingsBaseDocument {
    _id?: string;
  }

  export enum LANGUAGE {
    ENGLISH = 'en',
    HEBREW = 'he',
    SPANISH = 'es',
    JAPANESE = 'ja',
  }

  export const DEFAULT_LANGUAGE = LANGUAGE.ENGLISH;

  export enum THEME {
    LIGHT = 'light',
    DARK = 'dark',
  }

  export type Theme = 'light' | 'dark';

  export const langString: Record<LANGUAGE, string> = {
    [LANGUAGE.ENGLISH]: 'English',
    [LANGUAGE.HEBREW]: 'עברית',
    [LANGUAGE.SPANISH]: 'Español',
    [LANGUAGE.JAPANESE]: '日本語',
  };

  export const themeString = {
    light: 'Light',
    dark: 'Dark',
  };

  export enum HoursFormat {
    hours24,
    hours12,
  }

  export enum UiUserSettingsDateFormat {
    ddMMyy,
    MMddyy,
  }

  export interface GlobalSearchSettingsModel {
    markResult: boolean;
    includeAllMatch: boolean;
  }

  export const initialUserSettings: UserSettingsDocument = {
    dateFormat: UserSettingsModels.UiUserSettingsDateFormat.MMddyy,
    hoursFormat: UserSettingsModels.HoursFormat.hours12,
    autoLogout: 60, //value in minutes
    autoLogoutEnabled: false,
    theme: 'light',
    alertMonitoringMuted: true,
    lang: UserSettingsModels.LANGUAGE.ENGLISH,
    subForWeekly: true,
  };

  export const APP_INACTIVITY_TIME = 330;
  export const APP_INACTIVITY_THRESHOLD = 300;
  export const INACTIVITY_COUNTDOWN_SECONDS =
    APP_INACTIVITY_TIME - APP_INACTIVITY_THRESHOLD;

  export enum AccountDetailsSetting {
    FULL_NAME = 'fullName',
    EMAIL = 'email',
    PHONE = 'phone',
    DATE_TIME = 'dateTime',
    LANGUAGE = 'language',
    THEME = 'theme',
    WEEKLY_EMAILS = 'weeklyEmails',
    DEVICE_PAGE_VIEW = 'devicePageView',
    DEVICE_EMAILS = 'deviceEmails',
    GLOBAL_SEARCH = 'globalSearch',
    AUTO_LOGOUT = 'autoLogout',
  }

  export type AccountDetailsVisibility = Record<AccountDetailsSetting, boolean>;

  export interface AccountDetailsOptions {
    lastSyncedAt?: number;
  }
}
